import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {Text, TextSize, TextType} from '@Components/text';
import styles from './daily-limit-error.module.scss';

export function DailyLimitError(): ReactElement<HTMLDivElement> {
  return (
    <div className={`spacing-p-t-2 spacing-p-r-3 spacing-p-b-2 spacing-p-l-3 flex-row-align-center radius-8 ${styles.dailyLimitErrorContainer}`}>
      <Icon className={'content-danger'} icon={'icon-exclamation-triangle'} />
      <Text
        disableSelection
        className={'content-danger spacing-m-l-1'}
        type={TextType.BODY}
        size={TextSize.XSMALL}
        val={window.i18next.t('pmwjs_text_to_speech_daily_limit_reached_error_message')}
      />
    </div>
  );
}
